import store from '../../../core/store';
import { backendURL } from '../../../core/utils';
import { downloadFile } from '../general/downloader';

export const listCurrentSetPlans = (stage_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_CURRENT_SET_PLANS',
    method: 'GET',
    endpoint: '/stages/' + stage_id + '/plans/current',
    main: true,
  });
};

export const readPlanRevision = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/READ_PLAN_REVISION',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id,
    has404: true,
    main: true,
  });
};

export const readCurrentSetPlan = (plan_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/READ_CURRENT_SET_PLAN',
    method: 'GET',
    endpoint: '/plans/current/' + plan_id,
    has404: true,
  });
};

export const downloadLastRevision = (plan_id) => {
  return downloadFile(
    backendURL + '/plans/' + plan_id + '/download_last_revision',
    [],
    'POST'
  );
};

export const downloadPlanRevision = (plan_revision_id) => {
  return downloadFile(
    backendURL + '/plans/revisions/' + plan_revision_id + '/download',
    [],
    'POST'
  );
};

export const exportPlanRevision = (plan_revision_id, formData) => {
  return downloadFile(
    backendURL + '/plans/revisions/' + plan_revision_id + '/export',
    formData,
    'POST'
  );
};

export const downloadPlanFile = (plan_id, attachment_id) => {
  return downloadFile(
    backendURL + '/plans/' + plan_id + '/files/' + attachment_id,
    [],
    'POST'
  );
};

export const listPlanRevisionTasks = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_PLAN_REVISION_TASKS',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id + '/tasks',
  });
};

export const readPlanRevisionAnotation = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/READ_PLAN_REVISION_ANNOTATION',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id + '/annotations',
    has404: true,
  });
};

export const updatePlanRevisionAnotation = (plan_revision_id, objects) => {
  return store.dispatch({
    action: 'table.current_set_plans/UPDATE_PLAN_REVISION_ANNOTATION',
    method: 'PUT',
    endpoint: '/demo/plans/revisions/' + plan_revision_id + '/annotations',
    data: { data: objects },
  });
};

export const listPossiblePlanRevisionPlans = (plan_version_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_POSSIBLE_PLAN_REVISION_PLANS',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_version_id + '/possible_plans',
  });
};

export const attachPlanToPlanRevision = (plan_revision_id, formData) => {
  return store.dispatch({
    action: 'table.current_set_plans/ATTACH_PLAN_TO_PLAN_REVISION',
    method: 'POST',
    endpoint: '/plans/revisions/' + plan_revision_id + '/attach_plan',
    data: formData,
  });
};

export const togglePlanRevisionFavorite = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/TOGGLE_PLAN_REVISION_FAVORITE',
    method: 'POST',
    endpoint: '/plans/revisions/' + plan_revision_id + '/toggle_favorite',
  });
};

export const filterPlanRevisionAnnotations = () => {
  return store.dispatch({
    type: 'table.current_set_plans/FILTER_PLAN_REVISION_ANNOTATIONS',
  });
};

export const listPlanRevisionPlans = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_PLAN_REVISION_PLANS',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id + '/plans',
  });
};

export const listComparablePlanRevisions = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_COMPARABLE_PLAN_REVISIONS',
    method: 'GET',
    endpoint: '/plan_revisions/' + plan_revision_id + '/compares',
  });
};

export const listComparablePlanRevisionsByDiscipline = (plan_revision_id) => {
  return store.dispatch({
    action:
      'table.current_set_plans/LIST_COMPARABLE_PLAN_REVISIONS_BY_DISCIPLINE',
    method: 'GET',
    endpoint: '/plan_revisions/' + plan_revision_id + '/compares_by_discipline',
  });
};

export const listPossiblePlanRevisionSpecifications = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_PLAN_REVISION_SPECIFICATION_CODES',
    method: 'GET',
    endpoint:
      '/plans/revisions/' + plan_revision_id + '/possible_specification_codes',
  });
};

export const attachSpecificationToPlanRevision = (
  plan_revision_id,
  formData
) => {
  return store.dispatch({
    action:
      'table.current_set_plans/ATTACH_SPECIFICATION_CODE_TO_PLAN_REVISION',
    method: 'POST',
    endpoint:
      '/plans/revisions/' + plan_revision_id + '/attach_specification_code',
    data: formData,
  });
};

export const listPinnedPlanRevisionSpecifications = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_PINNED_PLAN_REVISION_SPECIFICATIONS',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id + '/pinned_specifications',
  });
};

export const listPossiblePlanRevisionByDiscipline = (plan_revision_id) => {
  return store.dispatch({
    action: 'table.current_set_plans/LIST_POSSIBLE_PLANS_BY_DISCIPLINE',
    method: 'GET',
    endpoint: '/plans/revisions/' + plan_revision_id + '/plans_by_discipline',
  });
};

export const searchPlanRevisionsTextOccurrences = (stage_id, query) => {
  return store.dispatch({
    action: 'table.current_set_plans/SEARCH_TEXT_OCCURRENCES_PLAN_REVISIONS',
    method: 'GET',
    endpoint: `/stages/${stage_id}/plans/search_occurrences?q=${encodeURIComponent(
      query
    )}&list=revisions`,
  });
};
